<div class="container-fluid">
    <app-page-title title="Settings" [breadcrumbItems]="breadCrumbItems"></app-page-title>

    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-md-2">
                        <div class="d-flex align-items-center mb-1">
                            <div class="col-md-2">
                                <div class="dataTables_length " id="tickets-table_length">
                                    <label class="d-inline-flex align-items-center">Show
                                        <select name="pageSize" [(ngModel)]="pageSize"
                                            class="form-control form-control-sm mx-2"
                                            (change)="getDiscounts(pageSize,0)">
                                            <option [ngValue]="5">5</option>
                                            <option [ngValue]="10">10</option>
                                            <option [ngValue]="25">25</option>
                                            <option [ngValue]="50">50</option>
                                            <option [ngValue]="100">100</option>
                                        </select> entries</label>
                                </div>
                            </div>
                            <div class="offset-md-8 col-md-2 text-end">
                                <button class="btn btn-primary" (click)="showDiscountModal()">
                                    <i class="uil uil-plus me-1"></i>Add Discount
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- Table -->
                    <div class="table-responsive">
                        <table id="basic-datatable"
                            class="table table-centered datatables dt-responsive nowrap table-card-list">
                            <thead>
                                <tr>
                                    <th class="text-center">Discount Name</th>
                                    <th class="text-center">Type</th>
                                    <th class="text-center">Discount</th>
                                    <th class="text-center">Cap Amount</th>
                                    <th class="text-center">Source</th>
                                    <!-- <th class="text-center">Applicable Staff</th> -->
                                    <th class="text-center">Validity</th>
                                    <th class="text-center">Created On</th>
                                    <th class="text-center">Active&nbsp;Status</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="isLoading">
                                <tr>
                                    <td colspan="9" class="text-center">
                                        <i class="fa fa-spin fa-spinner fa-pulse fa-5x m-auto"></i>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody *ngIf="!isLoading && discountList.length == 0">
                                <tr>
                                    <td colspan="9" class="text-center text-warning">
                                        No discounts found matching your criteria.
                                    </td>
                                </tr>
                            </tbody>
                            <tbody *ngFor="let table of discountList;let i=index">
                                <tr>
                                    <td class="text-center">
                                        <ngb-highlight>
                                            <a class="cpr text-info fw-bold" (click)="showDiscountModal(table.id)">
                                                {{table.discount_name}}
                                            </a>
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-center">
                                        <ngb-highlight>{{table.discount_type | titlecase}}</ngb-highlight>
                                    </td>
                                    <td class="text-center">
                                        <ngb-highlight>{{table.discount_type == 'percentage' ?
                                            table.discount + '%' : table.discount}}</ngb-highlight>
                                    </td>
                                    <td class="text-center">
                                        <ngb-highlight>{{table.cap_amount ? table.cap_amount : '-'}}</ngb-highlight>
                                    </td>
                                    <td class="text-center">
                                        <span class="badge bg-soft-info text-info me-1"
                                            *ngFor="let source of table.discount_source">{{source}}</span>
                                        <span *ngIf="!table.discount_source?.length">-</span>
                                    </td>
                                    <!-- <td class="text-center">
                                        <span class="badge bg-soft-secondary text-secondary me-1"
                                            *ngFor="let staff of table.applicable_staff">{{staff}}</span>
                                        <span *ngIf="!table.applicable_staff?.length">-</span>
                                    </td> -->
                                    <td class="text-center">
                                        <ngb-highlight *ngIf="table.valid_from || table.valid_to">
                                            {{table.valid_from ? (table.valid_from | date:'mediumDate') : 'Any'}} -
                                            {{table.valid_to ? (table.valid_to | date:'mediumDate') : 'No Expiry'}}
                                        </ngb-highlight>
                                        <ngb-highlight *ngIf="!table.valid_from && !table.valid_to">
                                            No Limit
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-center">
                                        <ngb-highlight>{{table.created_at*1000 | date:'medium'}}</ngb-highlight>
                                    </td>
                                    <td class="d-flex">
                                        <div class="form-check form-switch form-switch-lg m-auto" dir="ltr">
                                            <input type="checkbox" [(ngModel)]="table.is_active"
                                                class="form-check-input" (change)="discountStatus(table)">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- End table -->
                    <div class="row justify-content-md-between align-items-md-center mt-2">
                        <div class="col-sm-12 col-md-5">
                            <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                                Showing
                                {{(pageNumber-1)*pageSize + 1}} to
                                {{pageNumber*pageSize < page_details.count ? pageNumber*pageSize : page_details.count}}
                                    of {{page_details.count}} entries </div>
                            </div>
                            <!-- Pagination -->
                            <div class="col-sm-12 col-md-5">
                                <div class="text-md-end float-md-end pagination-rounded">
                                    <ngb-pagination [collectionSize]="page_details.count" [(page)]="pageNumber"
                                        [pageSize]="pageSize" (pageChange)="nextPage(pageNumber);">
                                    </ngb-pagination>
                                </div>
                            </div>
                            <!-- End Pagination -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> <!-- container-fluid -->
